module.exports = __webpack_public_path__ + "static/media/7114f42f-b81f-45cf-bca4-d443db9ed9d8-removebg-preview.27b8bd30.png";